import axios from "axios";
import { toStaticProxyUrl } from "./to-static-proxy-url";

/**
 * 下载文件的工具函数
 * @param fileUrl - 文件URL
 * @param fileName - 文件名
 */
export const downloadFile = async (fileUrl: string, fileName?: string): Promise<void> => {
  if (!fileUrl) {
    console.warn('fileUrl cannot be empty:', { fileUrl, fileName });
    return;
  }

  try {

    const reqUrl = toStaticProxyUrl(fileUrl);

    const response = await axios.get(reqUrl, {
      responseType: 'blob',
    });

    if (!response.data) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.data;

    // 创建下载链接
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || fileUrl.split('/').pop();

    // 添加到DOM并触发下载
    document.body.appendChild(a);
    a.click();

    // 清理资源
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error('下载失败:', error);

    // 如果fetch失败，回退到原始方法（直接跳转）
    try {
      const a = document.createElement("a");
      a.href = fileUrl;
      a.download = fileName || fileUrl.split('/').pop();
      a.target = '_blank'; // 添加target属性作为备选方案
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (fallbackError) {
      console.error('备用下载方法也失败:', fallbackError);
      // 最后尝试：直接打开新窗口
      window.open(fileUrl, '_blank');
    }
  }
};